import React from "react";
import { Grid } from "@mui/material";
import { SearchTextParamName } from "types";
import { FilterRow, FilterWrapper } from "components";
import { SearchTextFilter } from "modules/shared/filters/SearchTextFilter";

export const UserListFilter: React.FC = () => (
  <FilterWrapper>
    <FilterRow>
      <Grid item>
        <SearchTextFilter
          searchTextParamName={SearchTextParamName.SearchUser}
        />
      </Grid>
    </FilterRow>
  </FilterWrapper>
);
